import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import dateFormatConstant from '../../../constants/dateFormatConstant';
import ConformanceTooltip from './conformanceTooltip';
import DateTimePicker from '../../common/controls/dateTimePicker';
import { conformanceSelector, enabledSelector, labelSelector, newPathSelector, valueSelector, customerConfigurationSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import Label from './label';
import logValueOnChange from '../commonActions/logValueOnChange';
import localChangeSelector from '../selectors/localChangeSelector';
const DateTimePickerField = ({
  conformanceText: _conformanceText = null,
  enabled,
  label: _label = null,
  onChange,
  testingIdentifier: _testingIdentifier = 'default-id',
  value: _value = null,
  path,
  timePickerType: _timePickerType = '12hr',
  localChangeFunc,
  customerDateFormat: _customerDateFormat = 'month-first'
}) => {
  const dateFormat = dateFormatConstant[_customerDateFormat];
  const showConformance = !!_conformanceText;
  const handleChange = async updatedValue => {
    if (updatedValue !== _value) {
      const d = new Date(updatedValue);
      const log = {
        path,
        value: updatedValue,
        displayValue: d.toUTCString()
      };
      await onChange(localChangeFunc(log));
    }
  };

  /**
   * Handle when picker opens with no value - set default to current date+time
   */
  const handleOpen = () => {
    if (_value === null || _value === undefined) {
      // Get current time and represent it as a UTC ISO string
      const now = new Date();
      const currentDateTime = now.toISOString();
      handleChange(currentDateTime);
    }
  };
  const id = `dtpf-${kebabCase(_label)}`;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    "data-testid": id
  }, /*#__PURE__*/React.createElement(Label, {
    value: _label
  }), /*#__PURE__*/React.createElement(DateTimePicker, {
    viewMode: "days",
    timeFormat: _timePickerType === '24hr' ? 'HH:mm' : 'h:mm A',
    disabled: !enabled,
    onChange: handleChange,
    value: _value,
    onOpen: handleOpen,
    className: `${showConformance ? 'is-invalid' : ''} ${kebabCase(_testingIdentifier)} tqc-date-time-picker-field`,
    verticalPadding: false,
    dateFormat: dateFormat
  }), /*#__PURE__*/React.createElement(ConformanceTooltip, {
    errorText: _conformanceText,
    target: id
  }));
};
DateTimePickerField.propTypes = {
  conformanceText: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  path: PropTypes.string.isRequired,
  testingIdentifier: PropTypes.string,
  timePickerType: PropTypes.string,
  localChangeFunc: PropTypes.func.isRequired,
  customerDateFormat: PropTypes.string
};
export { DateTimePickerField as UncomposedDateTimePickerField };
export default entityComposition(DateTimePickerField, [], {
  conformanceText: conformanceSelector,
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector,
  localChangeFunc: localChangeSelector,
  customerDateFormat: customerConfigurationSelector
});